import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { SUPPORTED_LOCALES, translations } from '../content/translations';

const LocaleContext = createContext(null);

const normalizeLocale = (value) => {
  const normalized = String(value ?? '').toLowerCase().slice(0, 2);
  return SUPPORTED_LOCALES.includes(normalized) ? normalized : 'de';
};

export function LocaleProvider({ children }) {
  const [locale, setLocale] = useState(() => normalizeLocale(localStorage.getItem('ya-locale') || localStorage.getItem('ya-lang')));

  useEffect(() => {
    localStorage.setItem('ya-locale', locale);
    document.documentElement.lang = locale;
  }, [locale]);

  const changeLocale = useCallback(
    (nextValue) => {
      const next = normalizeLocale(nextValue);
      if (next !== locale) setLocale(next);
    },
    [locale],
  );

  const value = useMemo(
    () => ({ locale, t: translations[locale], changeLocale, isChanging: false }),
    [changeLocale, locale],
  );

  return (
    <LocaleContext.Provider value={value}>
      <div className="locale-stage">{children}</div>
      <span className="sr-only" aria-live="polite">
        {translations[locale].localeName}
      </span>
    </LocaleContext.Provider>
  );
}

export function useLocale() {
  const value = useContext(LocaleContext);
  if (!value) throw new Error('useLocale must be used inside LocaleProvider');
  return value;
}
